import type { VFC } from 'react';
import { Space } from 'antd';
import type { ResellersTab } from 'routes/resellers/enums/resellersTab';
import { Card } from 'components/enmon/card';
import { CreditInvoicesFilter } from './components/Filter';
import { ResellerCreditsTable } from './components/Table';

export const Credits: VFC<{ id: ResellersTab }> = () => {
  return (
    <Space className="w-100" direction="vertical">
      <Card>
        <CreditInvoicesFilter />
      </Card>
      <ResellerCreditsTable />
    </Space>
  );
};
